import { Box } from "@mui/material";

interface Props {
  value: string;
  onChange: (next: string) => void;
  disabled?: boolean;
  size?: number;
  testId?: string;
  ariaLabel?: string;
}

/**
 * Native `<input type="color">` wrapped in a visible outline so it stays
 * findable even when white-on-white. WebKit / Firefox draw their inner
 * swatch a few pixels inset - we strip that padding so the visible
 * colour fills the full square inside our border.
 *
 * Pass `disabled` to dim + lock (used by QR's "transparent background"
 * toggle which makes the bg color picker meaningless).
 */
export default function ColorSwatch({
  value,
  onChange,
  disabled,
  size = 36,
  testId,
  ariaLabel,
}: Props) {
  return (
    <Box
      component="input"
      type="color"
      value={value}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
        onChange(e.target.value)
      }
      disabled={disabled}
      data-testid={testId}
      aria-label={ariaLabel}
      sx={{
        width: size,
        height: size,
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 1,
        padding: 0,
        background: "transparent",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.4 : 1,
        flexShrink: 0,
        "&::-webkit-color-swatch-wrapper": { padding: 0 },
        "&::-webkit-color-swatch": { border: "none", borderRadius: 2 },
        "&::-moz-color-swatch": { border: "none", borderRadius: 2 },
      }}
    />
  );
}
